export const NAME_TYPE_ALERT = {
  NEGATIVE: 'Negative Alerts',
  UNREAD: 'Unread Alerts',
}

export const NAME_CHART = {
  COMPANY: 'totalAlertCompany',
  INDUSTRY: 'totalAlertIndustry',
  MACROECONOMIC: 'totalAlertMacroeconomic',
}
